import { Done } from '../../../../components/icons/done'
import { useNavigate } from 'react-router-dom'
import { paths } from '../../../../router/paths'
import { Button } from '../../../../components/button'
import { onboardingText, onboardingStyles } from '../styles/onboarding-styles'

export const Concluded = () => {
    const navigate = useNavigate()

        return (
            <div className={onboardingStyles.concludedWrapper}>
                <div className={onboardingStyles.concludedInner}>
                    <Done className="w-25 h-25 text-orange-500" />
                    <p className="text-center text-base font-normal text-black">
                        {onboardingText.concluded.success}
                    </p>
                    <div className="flex w-full flex-col items-center pt-6">
                        <Button
                            className={onboardingStyles.concludedButton}
                            onClick={() => navigate(paths.authentication.login)}
                        >
                            {onboardingText.concluded.cta}
                        </Button>
                    </div>
                </div>
            </div>
        )
}
